import { render, staticRenderFns } from "./VehicleContractFillRequests.vue?vue&type=template&id=6c24890b&scoped=true"
import script from "./VehicleContractFillRequests.vue?vue&type=script&lang=ts"
export * from "./VehicleContractFillRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24890b",
  null
  
)

export default component.exports